import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/honduran-milksnake.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const HonduranMilkSnake = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Honduran Milksnakes (Lampropeltis triangulum hondurensis)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/honduran-milksnake" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        I love all snakes that have red or orange on them so of course I love
        Honduran Milksnakes. The wild phenotypes - tricolors and tangerines -
        are amazing, and I like the albino version of each of them as well. And
        this kind of goes against what I just said but the anerythristic version
        is on my wish list too.
      </BodyText>
      <BodyText>
        I bought Saturcka when she was a baby and then it took almost 8 years
        for me to find a suitable partner for her. Now that I have him I have to
        wait a couple more years to get him up to size to breed with her and not
        become a late night snack instead.
      </BodyText>
      <PageGallery slug="honduran-milksnake" maxWidth="900" />
    </ContentBox>
  );
};

export default HonduranMilkSnake;
